import React from 'react';

import {
  Action,
  Actions as UIActions,
  EditIcon,
  DeleteIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

import {
  ACTION_EDIT,
  ACTION_DELETE,
} from 'scenes/Gallery/GalleryPage/OutsourceStudios/constants';

export default ({ actions, onEdit, onDelete }) => (
  <Permissions actions={actions}>
    {({ isActionAllowed }) => (
      <UIActions>
        <Action
          id={ACTION_EDIT}
          icon={<EditIcon />}
          label={'Edit'}
          disabled={!isActionAllowed('Edit')}
          onClick={onEdit}
        />
        <Action
          id={ACTION_DELETE}
          icon={<DeleteIcon />}
          label={'Delete'}
          disabled={!isActionAllowed('Delete')}
          onClick={onDelete}
        />
      </UIActions>
    )}
  </Permissions>
);
